import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber, propShape } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const SolutionTabPerformanceFeature = (props) => {
    const { currentIndex, item, organization, tabIndex } = props;
    if (tabIndex !== currentIndex) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'tab-content' }, { children: [item.performance && (_jsxs("div", { children: [_jsx("h2", { children: "\u5B9F\u7E3E" }), _jsx(SplitText, { text: item.performance })] })), organization.feature && (_jsxs("div", Object.assign({ className: `${item.performance ? 'mt3' : ''}` }, { children: [_jsx("h2", { children: "\u30D5\u30A1\u30FC\u30E0\u306E\u7279\u5FB4" }), _jsx(SplitText, { text: organization.feature })] })))] })));
};
SolutionTabPerformanceFeature.propTypes = {
    currentIndex: propNumber().isRequired,
    item: propShape().isRequired,
    organization: propShape().isRequired,
    tabIndex: propNumber().isRequired,
};
export default SolutionTabPerformanceFeature;
